<script setup lang="ts">
import { MYSTERY_BOX_TYPE } from '@/types/shared/player-config'
import TheBottomSheet from '@/components/TheBottomSheet.vue'
import { T } from '@tolgee/vue'
import MysteryBoxRewardItem from '@/components/MysteryBoxRewardItem.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { computed } from 'vue'
import type { OpenedMysteryBoxReward } from '@/types/mystery-box'
import { useAnalytics } from '@/composables/analytics'

const props = defineProps<{
  show: boolean
  item: OpenedMysteryBoxReward
  unopenedBoxes: Record<MYSTERY_BOX_TYPE, number>
}>()

const emit = defineEmits<{
  (e: 'hide'): void
  (e: 'open', boxType: MYSTERY_BOX_TYPE): void
}>()

const { triggerEvent } = useAnalytics()

const unopenedMysteryBoxCount = computed(() => props.unopenedBoxes[props.item.boxType])

function onOpenClick() {
  triggerEvent({ event: 'mystery_box_opened_instantly' })
  emit('open', props.item.boxType)
}
</script>

<template>
  <TheBottomSheet
    :show="show"
    content-class="pt-8"
    centered
    @hide="$emit('hide')"
  >
    <div
      class="w-full flex flex-col items-center"
    >
      <div class="text-light-white text-center text-2xl font-bold -tracking-[0.48px]">
        <T
          key-name="mystery_box.result.title"
          default-value="Yay! Box opened!"
        />
      </div>
      <div class="mt-3 text-white/[0.87] text-lg font-semibold text-center">
        <T
          key-name="mystery_box.result.description"
          default-value="Your box contains:"
        />
      </div>
      <div
        v-if="item.rewards"
        class="w-full mt-6 flex flex-col gap-y-1"
      >
        <MysteryBoxRewardItem
          v-for="(reward, index) in item.rewards"
          :key="index"
          class="benefit-box-glow"
          :reward="reward"
          show-checkmark
        />
      </div>
      <div class="w-full mt-6 flex flex-col gap-y-3">
        <BaseButton
          v-if="unopenedMysteryBoxCount > 0"
          class="w-full scale-up-light"
          @click="onOpenClick"
        >
          <template #leftIcon>
            <img
              class="h-full w-auto object-cover"
              src="@/assets/images/emojis/emoji-box.png"
            >
          </template>
          Open box ({{ unopenedMysteryBoxCount }} left)
        </BaseButton>
        <BaseButton
          v-else
          class="w-full scale-up-light"
          @click="$emit('hide')"
        >
          Buy more boxes
        </BaseButton>
      </div>
    </div>
  </TheBottomSheet>
</template>

<style scoped lang="scss">
@import "@/assets/styles/ecommerce";
</style>